import { AppState } from '../../types/store';

export const getModuleType = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).type;

export const getModuleVersion = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).version;

export const getModuleData = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleData || {};

export const getModuleConfig = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleConfig || {};

export const getModuleMeta = (state: AppState, moduleId) =>
  (state.modules[moduleId] || {}).moduleMeta || {};

export const getModuleDataByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.moduleData || {};
};

export const getModuleIdByModuleType = (
  state: AppState,
  moduleType: string
) => {
  const moduleRaw = findModules(state, m => m.type === moduleType).pop() || {};
  return moduleRaw.id || undefined;
};

export const getModules = (state: AppState) => state.modules || {};

export const findModules = (state: AppState, predicate: (m: any) => boolean) =>
  Object.keys(state.modules)
    .filter(key => predicate(state.modules[key]))
    .map(key => state.modules[key]);
